import React from 'react';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import Client from '../Client';
import { salesTop } from './simpleBiReportsApi';

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function formatedDate(value) {
  let date = new Date(value);
  const day = date.toLocaleString('default', { day: '2-digit' });
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.toLocaleString('default', { year: 'numeric' });

  return day + '-' + month + '-' + year;
}

class OverviewTopSales extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      sales_top: [],
      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    if (String(prevProps.location) !== String(this.props.location)) {
      this.getData();
    }
  }

  getData() {
    let queryData = {
      location: this.props.location ?? 0
    };
    let data = salesTop(this.state.client, queryData);

    if (data) {
      this.setState({ sales_top: data });
    }

    this.setState({ filterData: queryData });
  }

  doSync() {
    this.getData();
  }

  formatAmount(value) {
    const numberValue = parseInt(value || 0);

    if (numberValue > 1000000) {
      return thousandsSeparator((numberValue / 1000000).toFixed(2)) + " M";
    }

    return thousandsSeparator(numberValue.toFixed(0));
  }

  render() {
    let topSales = 0;
    let recordDate = "";

    if (this.state.sales_top) {
      let sales_top = this.state.sales_top;

      if (sales_top.recordDate !== undefined) recordDate = sales_top.recordDate;
      if (sales_top.recordSales !== undefined) topSales = parseInt(sales_top.recordSales);
    }

    return (
      <Card
        sx={{
          background: "#f6f4ef",
          overflow: 'hidden',
          position: 'relative',
          borderRadius: "14px",
          height: '100%'
        }}
      >
        <CardContent
          sx={{
            p: {
              xs: 1.2,
              sm: 1.5
            },
            "&:last-child": {
              pb: {
                xs: 1.2,
                sm: 1.5
              }
            },
            minHeight: {
              xs: 112,
              sm: 116,
              md: 112
            },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }}
        >
          <Stack
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            <Typography
              color="#1a237e"
              align="center"
              sx={{
                lineHeight: 1.2,
                fontSize: {
                  xs: "11px",
                  sm: "12px"
                },
                fontWeight: 800,
                letterSpacing: "0.5px",
                textTransform: "uppercase"
              }}
            >
              Sales Record
            </Typography>

            <Typography
              align="center"
              sx={{
                color: "#1e2833",
                fontWeight: 600,
                fontSize: {
                  xs: "28px",
                  sm: "28px",
                  md: "32px"
                },
                lineHeight: 1.1
              }}
            >
              {this.formatAmount(topSales)}
            </Typography>
          </Stack>

          {recordDate && (
            <Stack
              alignItems="center"
              justifyContent="center"
              direction="row"
              spacing={1}
              sx={{ mt: 1.25 }}
            >
              <Typography
                sx={{
                  color: "#1e2833",
                  fontSize: {
                    xs: "12px",
                    sm: "13px"
                  },
                  fontWeight: 400,
                  lineHeight: 1
                }}
              >
                {formatedDate(recordDate)}
              </Typography>

              <Typography
                color="text.secondary"
                sx={{
                  fontSize: {
                    xs: "11px",
                    sm: "12px"
                  },
                  lineHeight: 1
                }}
              >
                record date
              </Typography>
            </Stack>
          )}
        </CardContent>
      </Card>
    );
  }
}

export default OverviewTopSales;
